import SgdfTableNext from './table-next.component.js';
export * from './table-next.component.js';
export default SgdfTableNext;
SgdfTableNext.define('sgdf-table-next');
//# sourceMappingURL=table-next.js.map